<template>
  <!--商家登录-->
  <div class="l_body">
    <div class="l_head">登录</div>
    <div class="l_center" id="l_center">
      <div class="mbimg">
        <img src="../../../resource/img/yuanxingtupian.png" alt style="height:3.1rem;position: relative;right: -0.75rem;"/>
        <img src="../../../resource/img/gerenzhongxin-zhong.png" alt style="height:1.5rem;position: relative;right:1.6rem;top: 0.7rem;"/>
      </div>
      <div class="mbtittle">商家端</div>
      <div class="mbinput">
        <input type="text" class="toke-input" placeholder="账号" ref="username" v-model="formObj.username" @blur="blurIn"/>
        <input type="password" class="toke-input" placeholder="密码" ref="password" v-model="formObj.password" @blur="blurIn"/>
        <button class="toke-btn" @click="login">登录</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MerTokerMerLogin',
  data () {
    return {
      urlParam: {},
      formObj: {
        username: '',
        password: ''
      },
    }
  },
  created () {
    this.urlParam = this.$route.query
  },
  methods: {
    blurIn () {
      window.scrollTo(0, Math.max(this.scrollHeight - 1, 0))
    },
    login () {
      let that = this
      if (this.formObj.username == '' || this.formObj.username == null) {
        that.$message.warning('请输入用户名')
        return
      }
      if (this.formObj.password == '' || this.formObj.password == null) {
        that.$message.warning('请输入密码')
        return
      }
      that.$api.login({
        url: '/auth/login/union/merchant',
        login: false,
        data: {
          username: this.formObj.username,
          password: this.formObj.password
        }
      }).then(res => {
        that.$router.push({
          path: '/MerTokerMerIndex',
          query: {
            merId: this.urlParam.merId
          }
        })
      }).catch(err => {
        that.$message('登入失败')
      })

    },
  },
  computed: {
    scrollHeight () {
      return document.documentElement.scrollTop || document.body.scrollTop || 0
    }
  },
}
</script>
<style scoped>
body {
  background-color: #4a3a95;
}

.l_body {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #4a3a95;
  /* background-image: url("../../../resource/img/khdloginbg.png");*/
  z-index: 8;
}

.l_head {
  width: 100%;
  line-height: 3;
  height: 2.35rem;
  text-align: center;
  /* line-height: 17vh; */
  font-size: 40px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
}

/*.l_center {
  width: 100%;
  height: 80vh;
  text-align: center;
}*/
.l_center {
  width: 100%;
  position: absolute;
  z-index: -1;
  margin: 0;
  padding: 0;
}

.mbimg {
  display: flex;
  width: 100%;
  height: 4.53rem;
  justify-content: center;
}

.mbtittle {
  width: 100%;
  height: 0.79rem;
  font-size: 28px;
  font-family: PingFangSC-Regular;
  color: rgba(159, 141, 198, 1);
  text-align: center;
  line-height: 0.75vh;
}

.mbinput {
  width: 100%;
  height: 6.33rem;
  text-align: center;
}

.toke-input {
  width: 71.07%;
  height: 0.945rem;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 55px;
  margin-top: 0.45rem;
  border: none;
  letter-spacing: 2px;
  padding-left: 0.34rem;
  font-family: PingFangSC-Medium;
  color: #fff;
  font-size: 0.4rem;
  outline: none;
}

.toke-btn {
  width: 71.07%;
  height: 1rem;
  margin-top: 0.45rem;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 55px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 0.4rem;
  margin-top: 7vh;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/active/member/MerTokerMerLogin.vue